import { takeLatest } from 'redux-saga/effects';
import {
	getJobApplicantListSuccess, getJobApplicantListFail,
	getJobApplicantDetailsSuccess, getJobApplicantDetailsFail,
} from './jobApplicantState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/job-applicants');
const redirectData = {route:'/console/job-applicants', mode: 'list', recordId:0 };
const modelName = 'Job Applicant';
const modelId = 'jap_id';

const myCrudService = createCrudService('api/v1/my');

function* getJobApplicantList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getJobApplicantListSuccess, 
		getJobApplicantListFail, null, null, LOADING_MSG);
}

function* getJobApplicantDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getJobApplicantDetailsSuccess, 
		getJobApplicantDetailsFail, 
		null, null, LOADING_MSG);		
}

function* doJobApplicantCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getJobApplicantDetailsSuccess, 
		getJobApplicantDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		SAVING_MSG);
}

function* doJobApplicantUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getJobApplicantDetailsSuccess, 
		getJobApplicantDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		UPDATING_MSG);	
}

function* doJobApplicantDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getJobApplicantDetailsSuccess, 
		getJobApplicantDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* doApplyJob(data){
	yield doCrudCall(
		() => myCrudService.doPostRequest(`apply-job/${data.payload}`), 
		getJobApplicantDetailsSuccess, 
		getJobApplicantDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		'Sending application');
}

function* getMyJobApplicantList(data)
{
	yield doCrudCall(
		() => myCrudService.doGetRequest(`job-applications`, data.payload), 
		getJobApplicantListSuccess, 
		getJobApplicantListFail, null, null, LOADING_MSG);

}

function* jobApplicantSaga() {
	yield takeLatest('jobApplicant/getJobApplicantList', getJobApplicantList);
	yield takeLatest('jobApplicant/getJobApplicantDetails', getJobApplicantDetails);
	yield takeLatest('jobApplicant/doJobApplicantCreate', doJobApplicantCreate);
	yield takeLatest('jobApplicant/doJobApplicantUpdate', doJobApplicantUpdate);
	yield takeLatest('jobApplicant/doJobApplicantDelete', doJobApplicantDelete); 
	yield takeLatest('jobApplicant/doApplyJob', doApplyJob); 
	yield takeLatest('jobApplicant/getMyJobApplicantList', getMyJobApplicantList); 
	
}

export default jobApplicantSaga;
